import React from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Paper,
  Typography,
} from "@mui/material";
import { Controller, Control } from "react-hook-form";

interface ContentInformationSectionProps {
  control: Control<any>;
  viewMode: boolean;
  landingPages: any[];
}

export const ContentInformationSection: React.FC<
  ContentInformationSectionProps
> = ({ control, viewMode, landingPages }) => {
  return (
    <Paper sx={{ p: 3, mb: 3 }} elevation={1}>
      <Typography variant="h6" sx={{ mb: 3, fontWeight: 600, color: "#91278F" }}>
        Content Information
      </Typography>
      <Grid container spacing={2}>
        {/* Name */}
        <Grid item xs={12} md={6}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                label="Name"
                disabled={viewMode}
                value={field.value || ""}
              />
            )}
          />
        </Grid>

        

        {/* Content Listing Dropdown */}
        <Grid item xs={12} md={6}>
          <Controller
            name="content_id"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                fullWidth
                options={landingPages || []}
                getOptionLabel={(option: any) =>
                  option?.content_name ||
                  option?.title ||
                  `Content ID: ${option?.id}` ||
                  ""
                }
                value={
                  landingPages?.find((item: any) => item.id === field.value) ||
                  null
                }
                onChange={(_, newValue: any) => {
                  field.onChange(newValue?.id || null);
                }}
                disabled={viewMode}
                renderInput={(params) => (
                  <TextField {...params} label="Content Listing" />
                )}
              />
            )}
          />
        </Grid>
        {/* Description */}
        <Grid item xs={12} md={12}>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                label="Description"
                disabled={viewMode}
                multiline
                rows={3}
                value={field.value || ""}
              />
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

